/**
 * Glowing Track Bar — premium progress bar with gradient fill and glowing head dot.
 * Replaces lifeless plain progress bars. The "laser scanning" effect catches the eye.
 */
export default function GlowingTrackBar({ progress, color, lightColor, height = 'h-2' }) {
  const light = lightColor || lightenColor(color)
  const clampedProgress = Math.min(Math.max(progress, 0), 100)

  function lightenColor(hex) {
    if (!hex) return '#fff'
    return hex + '99'
  }

  return (
    <div className={`relative w-full ${height} rounded-full overflow-hidden bg-white/[0.04]`}>
      {/* Filled portion */}
      <div
        className="absolute inset-y-0 right-0 rounded-full transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)]"
        style={{
          width: `${clampedProgress}%`,
          background: `linear-gradient(90deg, ${color}, ${light})`,
        }}
      >
        {/* Glowing head dot — only for in-progress items */}
        {clampedProgress > 0 && clampedProgress < 100 && (
          <div
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-2 h-2 rounded-full"
            style={{
              backgroundColor: '#fff',
              boxShadow: `0 0 8px 2px ${color}80, 0 0 16px 4px ${color}40`,
            }}
          />
        )}
      </div>
    </div>
  )
}
